/* eslint-disable default-param-last, no-prototype-builtins */
import initialShape from './shapes';
import * as actionTypes from './types';

function setCityToCityData(state, action) {
    const {
        id,
    } = action.meta;

    return {
        ...state,
        [id]: action.payload,
    };
}

function setSelectedTimeTableDate(state, action) {
    const {
        id,
    } = action.meta;

    return {
        ...state,
        [id]: {
            ...state[id],
            timeTableDate: action.payload,
        },
    };
}

const reducerFunctions = {
    [actionTypes.SET_C2C_DATA]: setCityToCityData,
    [actionTypes.SET_SELECTED_TIME_TABLE_DATE]: setSelectedTimeTableDate,
};

export default function reducer(state = initialShape, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
